import { FinanceType } from '@upstart/harmony/lib/constants';
import { DeskingOfferCardProps } from './types';

// default residual percentages are set on the backend due to
// ms lender program markups
export function getDefaultResidualPercentage(): number {
  return 0;
}

export function getResidualPercentage({
  offer,
}: Pick<DeskingOfferCardProps, 'offer'>) {
  if (offer.data?.financeType !== FinanceType.LEASE) {
    return 0;
  }

  return offer.data.residualPercentage ?? getDefaultResidualPercentage();
}
